// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","fieldset":"_14SZVER","field_center":"_7X9uYye","button":"_24klri2"};